import { render, staticRenderFns } from "./vliveContentComment.vue?vue&type=template&id=84b58c26&"
import script from "./vliveContentComment.vue?vue&type=script&lang=js&"
export * from "./vliveContentComment.vue?vue&type=script&lang=js&"
import style0 from "./vliveContentComment.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports